export default class MobileNavigation {
  constructor(element) {
    this.triggers = element.querySelectorAll('.js-sidenavtrigger')
    this.backbuttons = element.querySelectorAll('.js-sidenavbacktrigger')

    if (!this.triggers || !this.backbuttons) {
      return
    }

    this.init()
  }

  init() {
    this.triggers.forEach((trigger) => {
      const subcontainer = trigger.closest('.has--dropdown')

      trigger.addEventListener('click', () => {
        if (subcontainer.classList.contains('is--active')) {
          subcontainer.classList.remove('is--active')
        } else {
          subcontainer.classList.add('is--active')
        }
      })
    })

    this.backbuttons.forEach((backbutton) => {
      const subcontainer = backbutton.closest('.has--dropdown')

      backbutton.addEventListener('click', () => {
        subcontainer.classList.remove('is--active')
      })
    })
  }
}
